import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pune-chess-tournament',
  templateUrl: './pune-chess-tournament.component.html',
  styleUrls: ['./pune-chess-tournament.component.scss']
})
export class PuneChessTournamentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
